import { bool } from "prop-types"

const RequiredInfoWarning = ({ isCurrentStep, isAdditionalInfoRequired }) => {
  if (!isCurrentStep || !isAdditionalInfoRequired) return null

  return (
    <div className="ta-c mt-4 alert info-alert">
      After you register, additional information will be required to complete
      your registration.
    </div>
  )
}

RequiredInfoWarning.propTypes = {
  isCurrentStep: bool,
  isAdditionalInfoRequired: bool,
}

export default RequiredInfoWarning
